import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import Donation from 'containers/donation';
import { ApiProvider } from 'lib/ApiContext';
import './tailwind.css';
import './i18n';

const Theme = (props) => (
  <ConfigProvider
    theme={{
      token: { colorPrimary: '#2e8634' }
    }}
    {...props}
  />
);

const donationForm = document.querySelector('#donation_form');

if (donationForm) {
  const reactRoot = ReactDOM.createRoot(donationForm);

  reactRoot.render(
    <React.StrictMode>
      <Theme>
        <ApiProvider>
          <Donation />
        </ApiProvider>
      </Theme>
    </React.StrictMode>
  );
}
